import { Component, OnInit } from '@angular/core';
import { UTrackUIEvent } from '@app/models/utrack-ui-event';
import { VennHealthDataService } from '@app/services/vennhealth-data.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor(private readonly vennhealthDataService: VennHealthDataService) { }

  ngOnInit(): void {
    const e: UTrackUIEvent = {
      details: 'About',
      additionalDetails: ''
    };
    this.vennhealthDataService.utrackEvent(e).subscribe();
  }

}
